import React from "react";
import { FormatWithCommas } from "@helpers/helpers";

/**
 * AmountCell Component
 * Displays formatted currency amount
 * @param {Object} row - The row data object
 */
const AmountCell = ({ row }) => {
  return (
    <span className="flex flex-col items-center justify-center group font-normal">
      <span>{`${row.original.Currency} ${FormatWithCommas(
        row.original.Amount
      )}`}</span>
    </span>
  );
};

export default AmountCell;
